import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Select, DatePicker, Tag } from 'antd';
import { ExTable } from 'icsoc-antd-ex';
import UnionSearch from 'Components/union/unionSearch';
import actions from 'Actions/taskManage/interactivePath';
import tDetailActions from 'Actions/taskManage/detail';
import moment from 'moment';
const {
    Filter,
    Filter: { NormalFilter },
} = ExTable;
const { Option } = Select;
const { RangePicker } = DatePicker;

class Search extends UnionSearch {
    componentDidMount() {
        const { tDetailActions } = this.props;
        // 获取任务名称，话术名称下拉框
        tDetailActions.getTaskNameOptions().then(res => {
            if (res.payload.data.length != 0)
                this.onOk({
                    ...this.props.searchData,
                    startMillis: moment().startOf('day').format("x"),
                    endMillis: moment().endOf('day').format("x"),
                    taskIds: res.payload.data[0].taskId
                })
        });
    }
    // 点击查询
    handleFilter = fields => {
        const { taskName, taskCommitDate, ...otherFields } = fields;
        const startMillis =
            taskCommitDate && taskCommitDate.length
                ? taskCommitDate[0].format('x')
                : undefined;
        const endMillis =
            taskCommitDate && taskCommitDate.length
                ? taskCommitDate[1].format('x')
                : undefined;
        let params = {
            ...otherFields,
            startMillis,
            endMillis,
        };
        if (params.taskIds) {
            params = { ...params, taskIds: params.taskIds.join(",") }
        }
        this.onOk(params);
    };
    render() {
        const { wordStrategyIdOptions, taskNameOptions } = this.props;
        return (
            <Filter handleFilter={this.handleFilter}>
                <NormalFilter>
                    <NormalFilter.Item label="时间范围" field="taskCommitDate" initialValue={[moment().startOf('day'), moment().endOf('day')]}>
                        <RangePicker
                            placeholder={['开始日期', '结束日期']}
                            showTime={{
                                hideDisabledOptions: true,
                                defaultValue: [
                                    moment('00:00:00', 'HH:mm:ss'),
                                    moment('23:59:59', 'HH:mm:ss'),
                                ],
                            }}
                            ranges={{
                                "今日": [moment().startOf('day'), moment().endOf('day')],
                                '昨日': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                                '本周': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                                '上周': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
                                '本月': [moment().startOf('month'), moment().endOf('month')],
                                '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                '今年': [moment().startOf('years'), moment().endOf('years')],
                                '去年': [moment().subtract(1, 'years').startOf('years'), moment().subtract(1, 'years').endOf('years')],
                            }}
                            // renderExtraFooter={renderExtraFooter}
                            format="YYYY-MM-DD HH:mm:ss"
                        />
                    </NormalFilter.Item>
                    <NormalFilter.Item label="任务名称" field="taskIds" initialValue={[taskNameOptions[0] && taskNameOptions[0].taskId]}>
                        <Select
                            mode="multiple"
                            showSearch
                            allowClear
                            placeholder="请选择任务"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }>
                            {Array.isArray(taskNameOptions)
                                ? taskNameOptions.map(({ taskId, taskName }) => (
                                    <Option value={taskId} key={taskId}>
                                        {taskName}
                                    </Option>
                                ))
                                : null}
                        </Select>
                    </NormalFilter.Item>
                </NormalFilter>
            </Filter>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.taskManageInteractivePath,
    taskNameOptions: state.taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    tDetailActions: bindActionCreators(tDetailActions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Search);
